import axios from 'axios';


const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'http://localhost:5000/api',
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

const privateJetService = {
  async submitInquiry(formData) {
    const response = await api.post('/private-jets/submit', formData);
    return response.data;
  },
  
  async getInquiries(page = 1, limit = 10, search = '', status = '') {
    const response = await api.get('/private-jets', {
      params: { page, limit, search, status }
    });
    return response.data;
  }
};

export default privateJetService;
